import React from 'react';
import { useIntl } from 'react-intl';
import { Breadcrumbs, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ProcessForm from '../ProcessForm';
import PageLayout from '../../PageLayout';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: '#F8F8F8',
  },
  toolbar: {
    backgroundColor: '#F8F8F8',
    zIndex: 1,
  },
  toolbarTitle: {
    color: '#F79A56',
    flexGrow: 1,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    backgroundColor: '#F8F8F8',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(2),
    },
  },
}));

function NewProcessPage() {
  const classes = useStyles();
  const intl = useIntl();
  const newProcessText = intl.formatMessage({ id: 'processes.new.title', defaultMessage: 'Nuevo' });
  const processesText = intl.formatMessage({ id: 'processes.title', defaultMessage: 'Procesos' });
  function NewProcessBreadcrumbs() {
    return (
      <Breadcrumbs className={classes.breadcrumbs} separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/processes" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{processesText}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}><strong>{newProcessText}</strong></Typography>
      </Breadcrumbs>
    );
  }

  return (
    <PageLayout title={newProcessText} breadCrumbs={<NewProcessBreadcrumbs />}>
      <ProcessForm data={null} />
    </PageLayout>
  );
}

export default NewProcessPage;
